<!--Deve atender todos os forms necessários para P&C -->
<template>
  <!--Dados do Sinistro -->
  <!--Bens Danificados -->
  <!--Dados de Vistoria -->
  <!-- Dados de Equipamento (apenas RD Equipamentos)-->

  <div v-if="objDTO !== null && currentAvisoId != 0">
    <div v-show="stage === 1">

   
      <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Linha de Negócio</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="LinhaDeNegocio"
              >Ramo</label
            >
            <InputText
              id="LinhaDeNegocio"
              name="LinhaDeNegocio"
              :value="objDTO.LinhaDeNegocio"
              readonly="readonly"
              class="form-control"
              :disabled="true"
            />
        
        </div>
      </div>
    </div></div>

      <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Corretor</b>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label" for="CorretorContactoNome"
              >Corretor</label
            >
            <InputText
              id="CorretorContactoNome"
              name="CorretorContactoNome"
              :value="objDTO.CorretorContacto.Nome"
              readonly="readonly"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.CorretorContacto.Email.$invalid,
            }"
          >
            <label class="form-label" for="CorretorContactoEmail"
              >E-mail do corretor</label
            >
            <InputText
              id="CorretorContactoEmail"
              name="CorretorContactoEmail"
              v-model="objDTO.CorretorContacto.Email"
              class="form-control"
            />
          </div>
          <div
            class="col-md-6"
            :class="{
              'field-required': $v.objDTO.CorretorContacto.Telefone.$invalid,
            }"
          >
            <label class="form-label" for="CorretorContactoTelefone"
              >Telefone do corretor</label
            >
            <mask-input
              id="CorretorContactoTelefone"
              name="CorretorContactoTelefone"
              v-model="objDTO.CorretorContacto.Telefone"
              type="text"
              class="form-control p-inputtext p-component" 
              :mask="MASKS.telemovel"
            :unmask="true"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container">
      <div class="white-frame" v-if="stage == 1">
        <div class="title-text mb-3">
          <b>Dados do Corretor</b>
        </div>
        <div class="row g-3"></div>

    <div
      class="col-md-23"
      v-if="riskUnits.length > 1"
      :class="{
        'field-required':
          validation.objDTO.Apolice.UnidadeDeRiscoExternalId.$invalid,
      }"
    >
      <label class="form-label" for="riskUnit">Unidade de Risco</label>
      <Dropdown
        id="riskUnit"
        :placeholder="riskUnits.length === 0 ? 'Carregando...' : 'Selecione uma unidade de risco'"
        v-model="objDTO.Apolice.UnidadeDeRiscoExternalId"
        :options="riskUnits"
        optionLabel="Description"
        optionValue="RiskUnitId"
        dataKey="DamageId"
        :filter="true"
        :showClear="true"
        class="form-control"
        @change="handleChangeRiskUnit"
        :loading="riskUnits.length === 0"
        :disabled="riskUnits.length === 0"
      />
    </div>
    <div
      class="col-md-12"
      :class="{
        'field-required':
          validation.objDTO.Apolice.ObjectoSeguradoExternalId.$invalid,
      }"
      v-if="objDTO.Apolice.UnidadeDeRiscoExternalId && insuranceObjects.length > 1"
    >
      <label class="form-label" for="insuranceObject">Objeto Segurado</label>
      <Dropdown
        id="insuranceObject"
        :placeholder="
          insuranceObjects.length === 0 ? 'Carregando...' : 'Selecione o objeto segurado'
        "
        v-model="objDTO.Apolice.ObjectoSeguradoExternalId"
        :options="insuranceObjects"
        optionLabel="Description"
        :filter="true"
        :showClear="true"
        optionValue="InsuranceObjectId"
        @change="handleChangeInsuranceObject"
        class="form-control"
        :loading="insuranceObjects.length === 0"
        :disabled="insuranceObjects.length <= 1"
      />
    </div>

    <div
      class="col-md-12"
      :class="{
        'field-required': validation.objDTO.Apolice.ApoliceCoberturaId.$invalid,
      }"
      v-if="objDTO.Apolice.ObjectoSeguradoExternalId"
    >
      <label class="form-label" for="coverages">Cobertura</label>
      <Dropdown
        id="coverages"
        :placeholder="coverages.length === 0 ? 'Carregando...' : 'Selecione a cobertura'"
        @change="changeCoverage"
        v-model="objDTO.Apolice.ApoliceCoberturaId"
        :options="coverages"
        :filter="true"
        :showClear="true"
        optionLabel="Description"
        optionValue="GisCoverageId"
        :loading="coverages.length === 0"
        class="form-control"
        :disabled="coverages.length <= 1"
      />
    </div>
    <div
      class="col-md-12"
      :class="{
        'field-required': validation.objDTO.Sinistro.SinistroEventoId.$invalid,
      }"
      v-if="objDTO.Apolice.ApoliceCoberturaId"
    >
      <label class="form-label" for="evento">Natureza</label>
      <Dropdown
        id="evento"
        :placeholder="events.length === 0 ? 'Carregando...' : 'Selecione a natureza do sinistro'"
        v-model="objDTO.Sinistro.SinistroEventoId"
        :options="events"
        optionLabel="Description"
        optionValue="Id"
        :showClear="true"
        :filter="true"
        :loading="events.length === 0"
        class="form-control"
        :disabled="events.length === 0"
      />
    </div>
  </div>
</div> -->

      <dados-sinistro
        :validation="$v"
        :events="events"
        :isLoadingEvents="events.length == 0"
        :showCountrySelector="!isEquipmentForm"
      >
        <template #dadosCoberturas>
          <dados-coberturas-eventos
            v-if="!loading.apoliceData"
            :coverages="coverages"
            :events="events"
            :validation="$v"
            :insuranceObjects="insuranceObjects"
            :riskUnits="riskUnits"
            @coverageChange="handleCoverageChange"
            @riskUnitChange="handleRiskUnitChange"
            @insuranceObjectChange="handleInsuranceObjectChange"
          />
          <loading-state-f-s v-else />
        </template>
      </dados-sinistro>

      <div class="container" v-if="stage == 1">
        <div class="white-frame">
          <div class="col-md-12">
            <div class="title-text mb-3">
              <b>Dados dos Bens Danificados</b>
            </div>
            <div
              class="col-md-12 pb-3"
              :class="{
                'field-required': $v.objDTO.Veiculo.Obs.$invalid,
              }"
            >
              <label class="form-label" for="bensSinistroDesc"
                >Descrição dos Bens</label
              >
              <Textarea
                id="bensSinistroDesc"
                v-model="objDTO.Veiculo.Obs"
                :autoResize="true"
                maxlength="1000"
                rows="5"
                cols="30"
                class="form-control"
              />
            </div>

            <div
              class="col-md-4"
              :class="{
                'field-required': $v.objDTO.Reserva.ValorReclamado.$invalid,
              }"
            >
              <label class="form-label" for="estimativaPrejuizo"
                >Estimativa de Prejuízo</label
              >
              <InputNumber
                id="estimativaPrejuizo"
                :minFractionDigits="2"
                :maxFractionDigits="2"
                v-model="objDTO.Reserva.ValorReclamado"
                :mode="undefined"
                :currency="undefined"
                class="form-control p-0"
                locale="pt-BR"
              />
            </div>
          </div>
        </div>
      </div>
     
      <dados-terceiros v-if="!isEquipmentForm"></dados-terceiros>
      <dados-vistoria v-on:replicarVistoria="replicarVistoria" :validation="$v"></dados-vistoria>

      <div class="container" v-if="!$v.objDTO.$invalid">
        <div class="col-12 Aligner aligner-right mt-4">
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="stage = 2"
          >
            Finalizar
          </button>
        </div>
      </div>
    </div>
    <div v-if="stage === 2">
      <resume-financial
          :coverages="coverages"
        :events="events"
        :riskUnits="riskUnits"
        :insuranceObjects="insuranceObjects"
        :objDTO="objDTO"
        :showEquipmentData="isEquipmentForm"
        @back="(v) => (stage = v)"
          />
    </div>
  </div>
  <loading-state-f-s v-else />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
  getCoverages,
  getEvents,
  getEventsByProductId,
  getFormDataByApoliceProdutoIdAndBranchId,
  getInsuranceObjects,
} from '../api/formMethods';
import DadosSinistro from '../components/areaNegocio/propertyCasualty/DadosSinistro.vue';
import DadosTerceiros from '../components/areaNegocio/financial/DadosTerceiros.vue';
import DadosVistoria from '../components/areaNegocio/financial/DadosVistoria.vue';
import DadosCoberturasEventos from '../components/DadosCoberturasEventos.vue';
import ResumeFinancial from '../components/Resume/ResumeFinancial.vue';
import { FORMS } from '../utils/constants';
import { getInfoByOperationPK } from '../utils/helpers';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { dateAfterToday, inputClean } from '../utils/customValidations';
import LoadingStateFS from '../components/LoadingStateFS.vue';
import Swal from 'sweetalert2';
import { email } from "vuelidate/lib/validators";
import { MASKS } from '../utils/constants';
import { IMaskComponent } from 'vue-imask';
import Textarea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';

export default {
  components: {
    'mask-input': IMaskComponent,
    Textarea,
    InputNumber,
    DadosTerceiros,
    DadosSinistro,
    DadosVistoria,
    ResumeFinancial,
    DadosCoberturasEventos,
    LoadingStateFS,
  },
  data() {
    return {
      loading: {
        apoliceData: false,
      },
      MASKS: MASKS,
      events: [],
      riskUnits: [],
      insuranceObjects: [],
      coverages: [],
      isEquipmentForm: false,
      currentAvisoId: 0,
      formName: 'Aviso de Sinistro',
      stage: 1,
      brasilPaisId: 3,
    };
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
    isBrasilSinistroSelected() {
      console.log('pais id sinistro', this.objDTO.Sinistro.SinistroPaisId);
      return this.objDTO.Sinistro.SinistroPaisId === this.brasilPaisId;
    },
    isBrasilVistoriaSelected() {
      console.log(
        'pais id vistoria',
        this.objDTO.Vistoria.VistoriaLocal.PaisId
      );
      return this.objDTO.Vistoria.VistoriaLocal.PaisId === this.brasilPaisId;
    },
  },
  async mounted() {
    console.log('mounted');
    if (!this.objDTO) {
      this.$router.push({ name: 'Home' });
      return;
    }

    // Inicializa valor estimado de reparação caso não exista
    if (!this.objDTO.Veiculo) {
      this.objDTO.Veiculo = {};
    }
    
    // Garante que o valor seja inicializado como número
    this.objDTO.Veiculo.ValorEstimadoReparacao = 
      this.objDTO.Veiculo.ValorEstimadoReparacao !== undefined && 
      this.objDTO.Veiculo.ValorEstimadoReparacao !== null ? 
      parseFloat(this.objDTO.Veiculo.ValorEstimadoReparacao) : 0;
    
    // Inicializa objeto Reserva caso não exista
    if (!this.objDTO.Reserva) {
      this.objDTO.Reserva = {};
    }
    
    // Garante que o valor reclamado seja inicializado como número
    this.objDTO.Reserva.ValorReclamado = 
      this.objDTO.Reserva.ValorReclamado !== undefined && 
      this.objDTO.Reserva.ValorReclamado !== null ? 
      parseFloat(this.objDTO.Reserva.ValorReclamado) : 0;
    
    //policy: "02852.2016.0001.0167.0000318"
    // this.objDTO.Apolice.ApoliceProdutoId = 105;
    // this.objDTO.Sinistro.SinistroRamoId = 67;
    // this.objDTO.Apolice.ApoliceContrato = 4655161847;

    // Load countries and states from API if not already loaded
    this.getOrSetCountries();
    this.getOrSetStatesBrasil();
    await this.policySelected(this.objDTO.Apolice.ApoliceContrato);

    if (!this.currentAvisoId) {
      Swal.fire({
        title: 'Erro',
        text: 'Não foi possível obter o formulário de aviso',
        icon: 'error',
        confirmButtonText: 'Ok',
      });

      this.$router.push({ name: 'Home' });
      return;
    }
  },
  validations() {
    const baseObj = {
      objDTO: {
        Veiculo: {
          Obs: { required },
        },
        Reserva: {
          ValorReclamado: { required }
        },
        Apolice: {
          ApoliceCoberturaId: { required },
          UnidadeDeRiscoExternalId: { required },
          ObjectoSeguradoExternalId: { required },
        },
        CorretorContacto: {
          Email: { email },
          Telefone: { required },
        },
        Sinistro: {
          SinistroData: { required, dateAfterToday },
          SinistroEventoId: { required },
          SinistroDescricao: { required },
          SinistroMorada: {
            required,
            inputClean,
          },
          SinistroMoradaNrPorta: { required },
          SinistroPaisId: {
            requiredIf: requiredIf(() => !this.isEquipmentForm),
          },
          SinistroPaisDescricao: {
            requiredIf: requiredIf(() => !this.isEquipmentForm),
          },
          SinistroDistritoId: {
            requiredIf: requiredIf(() => this.isBrasilSinistroSelected),
          },
          SinistroDistritoDescripton: { required, inputClean },
          SinistroConcelhoId: {
            requiredIf: requiredIf(
              () =>
                this.isBrasilSinistroSelected &&
                this.objDTO.Sinistro.SinistroDistritoId
            ),
          },
          SinistroConcelhoDescription: { required, inputClean },
          SinistroFreguesiaId: {
            requiredIf: requiredIf(
              () =>
                this.isBrasilSinistroSelected &&
                this.objDTO.Sinistro.SinistroConcelhoId
            ),
          },
          SinistroFreguesiaDescription: { required, inputClean },
        },
        Vistoria: {
          VistoriaLocal: {
            Telefone: { },
            Nome: { },
            Morada: { },
            CodPostalLocalidade: { },
            PaisId: { },
            PaisDescription: { },
            DistritoId: { },
            DistritoDescription: { },
            ConcelhoId: { },
            ConcelhoDescription: { },
            FreguesiaId: { },
            FreguesiaDescription: { }
          },
        },
      },
    };

    if (this.isEquipmentForm) {
      baseObj.objDTO.Veiculo = {
        ...baseObj.objDTO.Veiculo,
        Modelo: { required },
        ModeloAno: { required },
        NrChassis: { required },
      };

      baseObj.objDTO.ProcessoGDM = {
        Marca: { required },
        Modelo: { required },
      };
    }

    return baseObj;
  },
  methods: {
    ...mapMutations(['setLocalVistoria']),
    ...mapActions(['getOrSetCountries', 'getOrSetStatesBrasil']),
    replicarVistoria(){
      this.setLocalVistoria({
        Morada: this.objDTO.Sinistro.SinistroMorada,
        Telefone: this.objDTO.Sinistro.SinistroTelemovel || '',
        Nome: this.objDTO.Sinistro.SinistroNome || '',
        CodPostalLocalidade: this.objDTO.Sinistro.SinistroMoradaNrPorta || '',
        PaisId: this.objDTO.Sinistro.SinistroPaisId,
        PaisDescription: this.objDTO.Sinistro.SinistroPaisDescricao,
        DistritoId: this.objDTO.Sinistro.SinistroDistritoId,
        DistritoDescription: this.objDTO.Sinistro.SinistroDistritoDescripton,
        ConcelhoId: this.objDTO.Sinistro.SinistroConcelhoId,
        ConcelhoDescription: this.objDTO.Sinistro.SinistroConcelhoDescription,
        FreguesiaId: this.objDTO.Sinistro.SinistroFreguesiaId,
        FreguesiaDescription: this.objDTO.Sinistro.SinistroFreguesiaDescription,
        Obs: this.objDTO.Sinistro.SinistroObs || ''
      });

      this.$forceUpdate();
    },
    async handleRiskUnitChange() {
      this.objDTO.Apolice.ObjectoSeguradoExternalId = null;
      this.objDTO.Apolice.ApoliceCoberturaId = null;
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.insuranceObjects = [];
      this.coverages = [];
      this.events = [];

      if (this.objDTO.Apolice.UnidadeDeRiscoExternalId) {
        this.insuranceObjects = await getInsuranceObjects(
          this.objDTO.Apolice.ApoliceContrato,
          this.objDTO.Apolice.UnidadeDeRiscoExternalId
        );

        if (this.insuranceObjects && this.insuranceObjects.length == 1) {
          const object = this.insuranceObjects[0];

          this.objDTO.Apolice.ObjectoSeguradoExternalId =
            object.InsuranceObjectId;

          this.handleInsuranceObjectChange();
        }
      }
    },
    async handleInsuranceObjectChange() {
      this.objDTO.Apolice.ApoliceCoberturaId = null;
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.coverages = [];
      this.events = [];

      if (this.objDTO.Apolice.ObjectoSeguradoExternalId) {
        this.coverages = await getCoverages(
          this.objDTO.Apolice.ApoliceContrato,
          this.objDTO.Apolice.ObjectoSeguradoExternalId
        );
      }
    },
    async handleCoverageChange() {
      this.objDTO.Sinistro.SinistroEventoId = null;

      this.events = [];
      this.events = await getEvents(
        this.objDTO.Apolice.ApoliceProdutoId,
        this.objDTO.Apolice.ApoliceCoberturaId,
        this.objDTO.Sinistro.SinistroRamoId
      );

      if (!this.events || this.events.length == 0) {
        const eventsByProductId = await getEventsByProductId(
          this.objDTO.Apolice.ApoliceProdutoId
        );
        this.events = eventsByProductId;
      }
    },
    async policySelected(operationPK) {
      if (operationPK) {
        window.scrollTo(0, 0);

        const formData = await getFormDataByApoliceProdutoIdAndBranchId(
          this.objDTO.Apolice.ApoliceProdutoId,
          this.objDTO.Apolice.ApoliceCoberturaId
        );

        console.log(
          `Form Data: ApoliceProdutoId ${this.objDTO.Apolice.ApoliceProdutoId}`,
          formData
        );

        const formAvisoId = formData.Id;
        this.currentAvisoId = formAvisoId;
        this.formName = formData.Description;
        this.objDTO.FormAvisoId = formAvisoId;
        this.isEquipmentForm = formAvisoId === FORMS.RDEquipamentos;

        console.log('Is Equipment Form: ', this.isEquipmentForm);

        try {
          this.loading.apoliceData = true;

          const {
            riskUnit,
            riskUnits,
            insuranceObject,
            insuranceObjects,
            coverage,
            coverages,
            events,
          } = await getInfoByOperationPK(
            operationPK,
            this.objDTO.Apolice.ApoliceProdutoId,
            this.objDTO.Sinistro.SinistroRamoId
          );

          if (!events || events.length == 0) {
            const eventsByProductId = await getEventsByProductId(
              this.objDTO.Apolice.ApoliceProdutoId
            );
            this.events = eventsByProductId;
          } else {
            this.events = events;
          }

          this.objDTO.Apolice.UnidadeDeRiscoExternalId = riskUnit;
          this.objDTO.Apolice.ObjectoSeguradoExternalId = insuranceObject;
          this.objDTO.Apolice.ApoliceCoberturaId = coverage;
          this.riskUnits = riskUnits;
          this.insuranceObjects = insuranceObjects;
          this.coverages = coverages;

          console.log('events', this.events);
          console.log('riskUnits', this.riskUnits);
          console.log('insuranceObjects', this.insuranceObjects);
          console.log('coverages', this.coverages);
          console.log(
            'Unidade de Risco: ',
            this.objDTO.Apolice.UnidadeDeRiscoExternalId
          );
          console.log(
            'Objecto Segurado: ',
            this.objDTO.Apolice.ObjectoSeguradoExternalId
          );
          console.log('Cobertura: ', this.objDTO.Apolice.ApoliceCoberturaId);
        } catch (error) {
          console.error(error);
        } finally {
          this.loading.apoliceData = false;
        }
      }
    },
  },
};
</script>

<style>
.textAlignCenter {
  text-align: center;
}
</style>
